<template>
  <div>
    <!-- Desktop: 4-column CSS grid (hidden on mobile via v-show) -->
    <div class="news-grid" v-show="isDesktop">
      <ArticleCard
        v-for="article in articles"
        :key="article.id"
        :article="article"
        :currentUser="currentUser"
        @like="$emit('like', $event)"
        @dislike="$emit('dislike', $event)"
        @save="$emit('save', $event)"
        @navigate="(...args) => $emit('navigate', ...args)"
        @article-click="$emit('article-click', $event)"
        @unfollow-topic="$emit('unfollow-topic', $event)"
      />
    </div>

    <!-- Mobile: 2-column flex layout (hidden on desktop via v-show) -->
    <div class="news-grid" v-show="!isDesktop">
      <div class="column">
        <ArticleCard
          v-for="article in articlesColumn1"
          :key="article.id"
          :article="article"
          :currentUser="currentUser"
          @like="$emit('like', $event)"
          @dislike="$emit('dislike', $event)"
          @save="$emit('save', $event)"
          @navigate="(...args) => $emit('navigate', ...args)"
          @article-click="$emit('article-click', $event)"
          @unfollow-topic="$emit('unfollow-topic', $event)"
        />
      </div>
      <div class="column">
        <ArticleCard
          v-for="article in articlesColumn2"
          :key="article.id"
          :article="article"
          :currentUser="currentUser"
          @like="$emit('like', $event)"
          @dislike="$emit('dislike', $event)"
          @save="$emit('save', $event)"
          @navigate="(...args) => $emit('navigate', ...args)"
          @article-click="$emit('article-click', $event)"
          @unfollow-topic="$emit('unfollow-topic', $event)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ArticleCard from '@/components/ArticleCard.vue';

export default {
  name: 'ArticleGrid',

  components: { ArticleCard },

  props: {
    articles: {
      type: Array,
      required: true,
    },
    currentUser: {
      type: Number,
      default: null,
    },
    isDesktop: {
      type: Boolean,
      required: true,
    },
  },

  emits: ['like', 'dislike', 'save', 'navigate', 'article-click', 'unfollow-topic'],

  computed: {
    articlesColumn1() {
      return this.articles.filter((_, i) => i % 2 === 0);
    },
    articlesColumn2() {
      return this.articles.filter((_, i) => i % 2 !== 0);
    },
  },
};
</script>

<style scoped>
/* MAIN NEWS GRID */
.news-grid{
  height: fit-content;
  padding: 3% 3% 3% 3%;
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  grid-auto-rows: minmax(250px, auto);
  grid-auto-flow: dense;
  gap: 20px;
  background-color: #eeeff1;
  align-content: center;
}

@media (max-width: 913px) {
.news-grid {
  grid-template-columns: 1fr 1fr;
  gap: 15px;
  padding: 3vw 4vw 3vw 0vw;
}
}

@media (max-width: 649px) {
.news-grid {
  grid-template-columns: 1fr 1fr;
  gap: 15px;
  align-items: center;
  width: auto;
}
}

@media (max-width: 1300px) {
.news-grid{
  padding: 1%;
}
}

@media (max-width: 1024px) {
.news-grid{
  grid-template-columns: 1fr 1fr 1fr;
  padding: 1%;
}
}

@media (max-width: 1023px) {
  .news-grid{
  grid-template-columns: 1fr 1fr;
  padding: 3%;
      grid-column-gap: 0px;
}
}

@media (max-width: 649px) {
.column {
  flex: 0 1 100%; 
}
.news-grid {
display: flex;
align-items: flex-start;
justify-content: space-between;
gap: 20px; 
}

.column {
flex: 0 1 calc(50% - 10px); 
display: flex;
flex-direction: column;
gap: 20px;
}
}

@media screen and (max-width: 398px) {

.news-grid{
  padding: 10px !important;
}

}
</style>
